import { isNormalizedGraphError } from '@/graph/errors';

/** Renders a normalised Graph error with an honest, actionable message. */
export function ErrorNotice({ error }: { error: unknown }) {
  let title = 'Something went wrong';
  let body = 'An unexpected error occurred.';

  if (isNormalizedGraphError(error)) {
    if (error.isConsentRequired) {
      title = 'Consent needed';
      body = 'This tenant/admin has not consented to the scope this view needs.';
    } else if (error.isForbidden) {
      title = 'Not permitted (403)';
      body =
        'Your role or the tenant licensing does not allow this read. Some capabilities (e.g. agent inventory) are licence- or rollout-gated by design.';
    } else if (error.isThrottled) {
      title = 'Throttled by Graph (429)';
      body = 'Microsoft Graph is rate-limiting. The tool will back off and retry automatically.';
    } else {
      body = error.message;
    }
  } else if (error instanceof Error) {
    body = error.message;
  }

  return (
    <div className="notice notice--error" role="alert">
      <strong>{title}</strong>
      <p>{body}</p>
    </div>
  );
}
